import React, { useContext } from "react";
import NavBar from "../Components/NavBar";
import { useAnimateOnScroll } from "../Hooks/useAnimationScroll";
import { LanguageContext } from "../Hooks/langugaeContext";
import { useTranslation } from "../Hooks/useTranslation";

function CreditedInterestRate() {
  const translations = useTranslation();
  const { language } = useContext(LanguageContext);
  useAnimateOnScroll();

  const data = [
    {
      product: "Platinum",
      rows: [
        ["4/1/03 - 11/30/04", "6.00%"],
        ["12/1/04 - 5/31/05", "5.50%"],
        ["6/1/05 - 2/28/09", "5.00%"],
        ["3/1/09 - 3/31/10", "4.50%"],
        ["4/1/10 - 5/31/11", "4.25%"],
        ["6/1/11", "4.00%"],
      ],
    },
    {
      product: "Prime",
      rows: [
        ["7/1/17 - 10/31/19", "3.25%"],
        ["1/1/19", "3.00%"],
      ],
    },
    {
      product: "Platinum Ultra",
      rows: [
        ["7/1/05 - 2/28/09", "5.00%"],
        ["3/1/09 - 3/31/10", "4.75%"],
        ["4/1/10 - 5/31/11", "4.50%"],
        ["6/1/11 - 10/31/11", "4.00%"],
        ["11/1/11 - 9/30/12", "3.50%"],
        ["10/1/12 - 1/31/16", "3.25%"],
        ["2/1/16", "3.00%"],
      ],
    },
    {
      product: "Platinum Ultra II",
      rows: [
        ["1/1/12 - 9/30/14", "3.50%"],
        ["10/1/14-1/31/16", "3.25%"],
        ["2/1/16", "3.00%"],
      ],
    },
    {
      product: "Platinum Ultra III",
      rows: [
        ["2/1/14 - 10/31/19", "3.75"],
        ["11/1/19 - 3/31/22", "3.50"],
        ["4/1/22", "3.00%*"],
      ],
    },
    {
      product: "Optima",
      rows: [
        ["2/1/06 - 3/31/10", "4.50%"],
        ["4/1/10 - 5/31/11", "4.25%"],
        ["6/1/11 - 10/31/11", "3.75%"],
        ["11/1/11 - 1/31/16", "3.25%"],
        ["2/1/16", "3.00%"],
      ],
    },
    {
      product: "Optima Plus",
      rows: [
        ["3/1/13 - 1/31/16", "3.25%"],
        ["2/1/16", "3.00%"],
      ],
    },
    {
      product: "Optima Elite 90 – Optima Elite 110",
      rows: [
        ["1/1/15 - 10/31/19", "3.25%"],
        ["11/1/19", "3.00%"],
      ],
    },
  ];

  return (
    <div>
      <NavBar onlyWhiteBg={true} />
      <div>
        <div className="terms-privacy-container">
          <div className="container">
            <div className="font-semibold text-[40px] md:text-[60px] md:leading-[60px] leading-[44px] md:px-[4rem] text-left  ">
              Credited <span className="breakwordMobile">Interest Rate</span>
            </div>
            <div className="min-h-screen mt-[2rem] mb-[3rem]">
              <div className="mx-auto creditdInterestTable bg-white rounded-[20px] overflow-auto ">
                <table className="w-full table-auto ">
                  <thead className="bg-[#0D4248] text-white">
                    <tr>
                      <th className="px-4 py-2 pt-[39px] border border-[#0D4248] text-left w-[20%]">
                        Universal Life Insurance Products
                      </th>
                      <th className="px-4 py-2 pt-[39px] border border-[#0D4248] text-left w-[40%]">
                        Date Range
                      </th>
                      <th className="px-4 py-2 pt-[39px] border border-[#0D4248] text-left w-[40%]">
                        Credited Interest Rate
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-[#000000]">
                    {data.map((group, groupIdx) =>
                      group.rows.map(([date, rate], rowIdx) => (
                        <tr key={`${group.product}-${rowIdx}`} className="">
                          {rowIdx === 0 && (
                            <td
                              rowSpan={group.rows.length}
                              className="px-4 py-2 font-semibold border border-[#DCDDDE] align-center text-[14px] md:text-[16px]  "
                            >
                              {group.product}
                            </td>
                          )}
                          <td className="px-4 py-2 border border-[#DCDDDE] text-[14px] md:text-[16px]">
                            {date}
                          </td>
                          <td className="px-4 py-2 border border-[#DCDDDE] text-[14px] md:text-[16px]">
                            {rate}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div class="md:text-[#706F6F] text-[#706F6F]">
              <div class="mt-1 text-[12px] md:text-sm">
                <p class="mb-6 text-center lg:text-left text-[14px]">
                  <a
                    href="https://www.dropbox.com/scl/fi/67wweykfzdwpfj50479nl/FCR2024.pdf?rlkey=m4i3k1om27f9i1luijt76pavd&e=1&st=wya0xg6m&dl=0"
                    target="_blank"
                  >
                    <u>Click here</u>
                  </a>
                   for the Financial Conditions Report of American Fidelity
                  International Ltd.
                </p>
                <p class="text-justify">
                  * Platinum Ultra III offers a current interest rate that may
                  vary by policy year. 3.00% is the current credited interest
                  rate for policy years 1-20 and 3.50% is the current credited
                  interest rate for policy years 21+.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreditedInterestRate;
